import React from 'react'
import Carousel from 'react-elastic-carousel';

import southland from './images/southland-shop.jpg'
import hg from './images/hammond-grange-shop.jpg';
import equip from './images/equip-solutions-shop.jpg';
import dezign from './images/dezign-shop.jpg';
import wolplein from './images/wolplein-shop.jpg';
import czo from './images/czo-shop.jpg';

import equipModal from './images/equip-screenshot.png';
import wolpleinModal from './images/wolplein-screenshot.png';
import czoModal from './images/czo-screenshot.png';


import Lines from './parts/Lines';

export default function Projects() {
  const breakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 550, itemsToShow: 2 },
        { width: 768, itemsToShow: 3 }
   ];

   function projectModal(img){
     document.getElementById("modal-img").src = img;
   }

   return (
     <>
      <div id="project" className="projects container">
        <div className="row">
        <Carousel
          breakPoints={breakPoints}
          itemsToShow={3}
          enableSwipe={true}
          pagination={false}
          showArrows={true}
        >
          <div className="project">
            <div className="ui-project">
               <div className="ui-text">Project</div>
            </div>
            <a href="https://www.southland.com.au/" target="_blank" className="project-image">
              <img src={southland} className="image" />
              <div className="overlay"></div>
            </a>
            <div className="project-information">
              <h4>Southland Supply Group</h4>
              <p>Redeveloped existing webshop using Magento 2. Includes maintaining and building custom modules to improve user experience and to optimize the workflow.</p>
              <ul className="project-tech">
                <li>Magento 2</li>
                <li>PHP</li>
                <li>RequireJS</li>
                <li>CSS3</li>
                <li>Knockout.js</li>
                <li>Microsoft Dynamics 365</li>
              </ul>
              <div className="button-section">
                <a href="https://www.southland.com.au/" role="button" className="btn" target="_blank"><i className="fa fa-external-link"></i> Project</a>
              </div>
            </div>
          </div>
          <div className="project">
            <div className="ui-project">
               <div className="ui-text">Project</div>
            </div>
            <a href="https://www.hammondandgrange.com.au/" target="_blank" className="project-image">
              <img src={hg} className="image" />
              <div className="overlay"></div>
            </a>
            <div className="project-information">
              <h4>Hammond & Grange</h4>
              <p>Redesigned and implemented various custom build plugins to improve customer interactions and the user experience as a whole.</p>
              <ul className="project-tech">
                <li>Wordpress</li>
                <li>PHP</li>
                <li>Woocommerce</li>
              </ul>
              <div className="button-section">
                <a href="https://www.hammondandgrange.com.au/" role="button" className="btn" target="_blank"><i className="fa fa-external-link"></i> Project</a>
              </div>
            </div>
          </div>
          <div className="project">
            <div className="ui-project">
               <div className="ui-text">Project</div>
            </div>
            <a href="https://www.southland.com.au/" target="_blank" className="project-image">
              <img src={equip} className="image" />
              <div className="overlay"></div>
            </a>
            <div className="project-information">
              <h4>Equip Solutions - by Southland Supply Group</h4>
              <p>Maintained and implemented various functionalities to improve the process management for this B2B-Webshop build with Magento 1.</p>
              <ul className="project-tech">
                <li>Magento 1</li>
                <li>PHP</li>
                <li>Zend</li>
                <li>SCSS</li>
              </ul>
              <div className="button-section">
                <button type="button" className="btn" data-bs-toggle="modal" data-bs-target="#project-modal" onClick={() => projectModal(equipModal)}><i className="fa fa-external-link"></i> Project</button>
              </div>
            </div>
          </div>
          <div className="project">
            <div className="ui-project">
               <div className="ui-text">Project</div>
            </div>
            <a href="https://dezign.net.au/" target="_blank" className="project-image">
              <img src={dezign} className="image" />
              <div className="overlay"></div>
            </a>
            <div className="project-information">
              <h4>Dezign</h4>
              <p>Designed and build a new website to give a refreshing look to this interior fit-out firm.</p>
              <ul className="project-tech">
                <li>Wordpress</li>
                <li>PHP</li>
              </ul>
              <div className="button-section">
                <a href="https://dezign.net.au/" role="button" className="btn" target="_blank"><i className="fa fa-external-link"></i> Project</a>
              </div>
            </div>
          </div>
          <div className="project">
            <div className="ui-project">
               <div className="ui-text">Project</div>
            </div>
            <div className="project-image"  data-bs-toggle="modal" data-bs-target="#project-modal" onClick={() => projectModal(wolpleinModal)}>
              <img src={wolplein} className="image" />
              <div className="overlay"></div>
            </div>
            <div className="project-information">
              <h4>Wolpein</h4>
              <p>Helped maintaining one of the biggest dutch online webshops for wool & garments.</p>
              <ul className="project-tech">
                <li>Magento 1</li>
                <li>PHP</li>
              </ul>
              <div className="button-section">
                <button type="button" className="btn" data-bs-toggle="modal" data-bs-target="#project-modal" onClick={() => projectModal(wolpleinModal)}><i className="fa fa-external-link"></i> Project</button>
              </div>
            </div>
          </div>
          <div className="project">
            <div className="ui-project">
               <div className="ui-text">Project</div>
            </div>
            <div className="project-image" data-bs-toggle="modal" data-bs-target="#project-modal" onClick={() => projectModal(czoModal)}>
              <img src={czo} className="image" />
              <div className="overlay"></div>
            </div>
            <div className="project-information">
              <h4>Weather API</h4>
              <p>Project developed while working as an intern for Aemotion. And made in request for the news company CulemborgZO. This was made as an upgrade of their old weather forecast section.</p>
              <ul className="project-tech">
                <li>Javascript</li>
                <li>Open-Meteo API</li>
              </ul>
              <div className="button-section">
                <button type="button" className="btn"  data-bs-toggle="modal" data-bs-target="#project-modal" onClick={() => projectModal(czoModal)}><i className="fa fa-external-link"></i> Project</button>
              </div>
            </div>
          </div>
          </Carousel>
        </div>
      </div>
      <Lines></Lines>
      <div className="modal fade" id="project-modal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <img src="#" id="modal-img"></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
